(function (doc, win) {
  const docEl = doc.documentElement;
  //当设备的方向变化（设备横向持或纵向持）此事件被触发。绑定此事件时，
  //注意现在当浏览器不支持orientationChange事件的时候我们绑定了resize 事件。
  //总来的来就是监听当然窗口的变化，一旦有变化就需要重新设置根字体的值
  const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
  const recalc = function () {
    const wh = docEl.clientWidth || 375;
    let clientWidth = wh;
    if (wh <= 320) {
      clientWidth = 320;
    }
    if (wh >= 414) {
      clientWidth = 414;
    }
    //设置根字体大小
    docEl.style.fontSize = clientWidth * 2 / 7.5 + 'px';
  };
//绑定浏览器缩放与加载时间
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);



// WEBPACK FOOTER //
// ./src/config/rem.js